var $94e4262f3b79d866$exports = {};
$94e4262f3b79d866$exports = {
    "pending": `pending`
};


export {$94e4262f3b79d866$exports as default};
//# sourceMappingURL=en-US.module.js.map
